<template>
  <svg
    width="24"
    height="26"
    viewBox="0 0 24 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 11.268C23.8333 12.0378 23.8333 13.9622 22.5 14.732L3.75 25.5574C2.41667 26.3272 0.750004 25.3649 0.750005 23.8253L0.750005 2.17468C0.750006 0.635079 2.41667 -0.327169 3.75001 0.442631L22.5 11.268Z"
      fill="currentColor"
    />
  </svg>
</template>
